/* tslint:disable */
/* eslint-disable */
/**
 * Public Track API
 * Public Track APIs provide customers access to their SPiDRs, Security Focuses and SPiDR Blueprints
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 */
export const SpidrImprovement = {
    MorePersonalizedRecommendations: 'More personalized recommendations',
    MorePracticalClearRecommendations: 'More practical/clear recommendations',
    BetterCommunicationClarityOfFindings: 'Better communication/clarity of findings',
    MoreActionableInsights: 'More actionable insights',
    MoreDetailedAssessment: 'More detailed assessment',
    FasterCompletionTime: 'Faster completion time',
    BetterFollowUpSupport: 'Better follow-up/support'
};
export function SpidrImprovementFromJSON(json) {
    return SpidrImprovementFromJSONTyped(json, false);
}
export function SpidrImprovementFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function SpidrImprovementToJSON(value) {
    return value;
}
